import React, { useEffect, useState } from "react";
import { Button, message, Table, Modal } from "antd";
import IndicatorModal from "./IndicatorModal";
import RenderTxt from "../../../../components/renderTxt";
import SystemApi from "../../../../api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { stationApi } from "@api/newApi";

const operatorTypeEnum = {
  0: "等于",
  1: "大于",
  2: "大于等于",
  3: "小于",
  4: "小于等于",
};

export default ({ gatherDevId, processUnitId }) => {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : {};

  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [visible, setVisible] = useState(false);
  const [formState, setFormState] = useState({});
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState({});
  const [diyAttrList, setDiyAttrList] = useState([]);

  const columns = [
    {
      title: "告警名称",
      dataIndex: "alarmName",
      align: "center",
      key: "alarmName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "告警值",
      dataIndex: "alarmValue",
      align: "center",
      key: "alarmValue",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "工艺点",
      dataIndex: "attrName",
      align: "center",
      key: "attrName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "运算符",
      dataIndex: "operatorType",
      align: "center",
      key: "operatorType",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => operatorTypeEnum[text],
    },
    {
      title: "状态",
      dataIndex: "indicatorState",
      align: "center",
      key: "indicatorState",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (text == 1 ? "开启" : "关闭"),
    },
    {
      title: "权重",
      dataIndex: "weight",
      align: "center",
      key: "weight",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button
              type="primary"
              style={{ marginRight: 8 }}
              onClick={() => editRecord(obj)}
            >
              编辑
            </Button>
            <Button type="primary" danger onClick={() => delRecord(obj)}>
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (processUnitId) {
      getProcessUnitAttr();
    }
  }, [processUnitId]);

  useEffect(() => {
    if (gatherDevId) {
      getListByPages();
    }
  }, [searchParams, gatherDevId]);

  const getProcessUnitAttr = () => {
    stationApi.findUnitDisplayDetail(stationId, processUnitId).then((res) => {
      if (res.status !== "0") return;
      const { diyAttrList } = res.data;
      setDiyAttrList(diyAttrList);
    });
  };

  const getListByPages = () => {
    setLoading(true);
    SystemApi.pointIndicatorList({
      ...searchParams,
      gatherDevId,
    }).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data &&
        data.map((item) => {
          item.key = item.id;
        });
      setDataSource(res.data);
    });
  };

  const editRecord = (obj) => {
    setFormState(obj);
    setVisible(true);
  };

  const delRecord = (obj) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.pointIndicatorRemove({ id: obj.id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          if (dataSource.data.length == 1 && searchParams.pageNum > 1) {
            setSearchParams({
              ...searchParams,
              pageNum: searchParams.pageNum - 1,
            });
          } else {
            getListByPages();
          }
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const addRecord = () => {
    if (!gatherDevId) return message.error("请选择设备");
    setFormState({});
    setVisible(true);
  };

  const onCancel = (bool) => {
    setVisible(false);
    bool && getListByPages();
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Button type="primary" style={{ marginBottom: 20 }} onClick={addRecord}>
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={dataSource.data}
        pagination={{
          current: dataSource.pageNum,
          pageSize: dataSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: dataSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <IndicatorModal
          diyAttrList={diyAttrList}
          formState={formState}
          onCancel={onCancel}
        />
      )}
    </div>
  );
};
